import { ProcessColumnIdentifier } from "./ProcessList";
import { ProcessWithStatus } from "./ProcessWithStatus";
import { getVisibleColumnsFromStore } from "./VisibleColumnsStore";
import { getCountsTimeLimitDaysFromStore } from "./CountsTimeLimitDaysStore";
import { ProcessTemplate } from "processTemplates/model/ProcessTemplate";

export class ListState {
    public selectedProcessIds: number[];
    public columnVisibilityControlOpen: boolean;
    public visibleColumns: Array<keyof (ProcessWithStatus)>;
    public tagModalOpenForProcesses: number[] | null;
    public isSubprocessList: boolean;
    public countsTimeLimitDays: number;
    public changeLogOpenForProcess: number | null;
    public processVariablesEditorOpenForProcess: number | null;
    public actionMenuOpenForProcess: number | null;
    public selectCreateTemplateFromProcessModeModal: TemplateModalProps | null;
    public createTemplateFromProcessModal: TemplateModalProps | null;
    constructor(isSubprocessList?: boolean) {
        this.selectedProcessIds = [];
        this.isSubprocessList = isSubprocessList || false;
        this.columnVisibilityControlOpen = false;
        this.visibleColumns = getVisibleColumnsFromStore(this.isSubprocessList);
        this.countsTimeLimitDays = getCountsTimeLimitDaysFromStore();
    }
}

const sharedColumns: ColumnWithLabel[] = [
    { column: ProcessColumnIdentifier.erroredNotAcknowledged, label: FRENDS.Localizations.ProcessInstanceFilter_ShowFailedNotAcknowledged },
    { column: ProcessColumnIdentifier.latestExecutionStartTime, label: FRENDS.Localizations.LatestExecutionStartTime },
    { column: ProcessColumnIdentifier.frendsVersion, label: "Frends version" },
    { column: ProcessColumnIdentifier.tags, label: FRENDS.Localizations.TagString },
    { column: ProcessColumnIdentifier.promotedResultVariables, label: FRENDS.Localizations.PromotedColumn },
    { column: ProcessColumnIdentifier.usedProcessesList, label: FRENDS.Localizations.Subprocesses },
    { column: ProcessColumnIdentifier.usedByProcessesList, label: FRENDS.Localizations.UsedByProcesses },
    { column: ProcessColumnIdentifier.executionsPerDay, label: FRENDS.Localizations.LatestInstancesPerDay },
    { column: ProcessColumnIdentifier.running, label: FRENDS.Localizations.ProcessInstanceFilter_ShowRunning },
    { column: ProcessColumnIdentifier.successful, label: FRENDS.Localizations.ProcessInstanceFilter_ShowSuccessful },
    { column: ProcessColumnIdentifier.failed, label: FRENDS.Localizations.ProcessInstanceFilter_ShowFailed },
    { column: ProcessColumnIdentifier.triggers, label: FRENDS.Localizations.ActiveTriggers },
    { column: ProcessColumnIdentifier.modified, label: FRENDS.Localizations.Modified },
    { column: ProcessColumnIdentifier.modifier, label: FRENDS.Localizations.Modifier },
    { column: ProcessColumnIdentifier.logLevel, label: FRENDS.Localizations.LogLevel },
    { column: ProcessColumnIdentifier.logRetention, label: "Log retention" }
]

export const ProcessListColumns: ColumnWithLabel[] = [
    { column: ProcessColumnIdentifier.id, label: FRENDS.Localizations.Id },
    { column: ProcessColumnIdentifier.uniqueIdentifier, label: "GUID" },
    { column: ProcessColumnIdentifier.targetFramework, label: "Target framework" },
    { column: ProcessColumnIdentifier.latestExecutionState, label: FRENDS.Localizations.LatestExecutionState },
    { column: ProcessColumnIdentifier.template, label: "Template" },
    ...sharedColumns
];

export const selectableSubprocessListColumns: ColumnWithLabel[] = [
    { column: ProcessColumnIdentifier.id, label: FRENDS.Localizations.Id },
    { column: ProcessColumnIdentifier.uniqueIdentifier, label: "GUID" },
    { column: ProcessColumnIdentifier.targetFramework, label: "Target framework" },
    { column: ProcessColumnIdentifier.template, label: "Template" },
    ...sharedColumns
];

// Regular processes can never be subprocesses, so "Used by processes" is not offered on the Process list.
export const selectableProcessListColumns: ColumnWithLabel[] =
    selectableSubprocessListColumns.filter((c) => c.column !== ProcessColumnIdentifier.usedByProcessesList);

export enum SortByExeutionColumns {
    running = ProcessColumnIdentifier.running,
    failed = ProcessColumnIdentifier.failed,
    successful = ProcessColumnIdentifier.successful,
    executionsPerDay = ProcessColumnIdentifier.executionsPerDay,
    erroredNotAcknowledged = ProcessColumnIdentifier.erroredNotAcknowledged,
    latestExecutionStartTime = ProcessColumnIdentifier.latestExecutionStartTime
}

export enum FilterCategory {
    Text = "Text",
    Tags = "Tags",
    Tasks = "Tasks",
    TriggerName = "TriggerName",
    TriggerType = "TriggerType",
    ErrorsSince = "ErrorsSince",
    ExecutionsSince = "ExecutionsSince",
    PromotedResultVariables = "PromotedResultVariables",
    UsedBy = "UsedBy",
    Subprocesses = "Subprocesses"
}

export interface TemplateModalProps {
    processId: number;
    existingTemplate?: ProcessTemplate;
}

interface ColumnWithLabel {
    column: keyof (ProcessWithStatus);
    label: string;
} 